import { RouteType } from "types/RouteType";
import type ClientInquiryAnswersStore from "./ClientInquiryAnswersStore";

const storeOf = (rootStore: unknown) =>
  (rootStore as { clientInquiryAnswersViewStore?: ClientInquiryAnswersStore })
    .clientInquiryAnswersViewStore;

/**
 * Clients → Client Inquiries: every client's answers to our design/data
 * questions, newest answered first.
 *
 * Gate: `requiresAuth` only, like Clients and Client Risk. The API's read gate
 * is `requireStaffRead()` (any authenticated staff user, viewer tier and up)
 * plus `denyApiKeyPrincipal`, and it is the real boundary; this route mirrors
 * it rather than narrowing it.
 *
 * No realtime: the service publishes no events. The viewport card's Refresh
 * button re-runs onEnter, and the grid has its own Refresh control.
 */
const clientInquiriesRoute: RouteType[] = [
  {
    name: "ClientInquiries",
    path: "/clients/inquiries",
    layout: "/app",
    viewportCard: {
      header: {
        enableBackButton: true,
        title: "Client Inquiries",
        enableRefreshButton: true,
        component: () => import("./ClientInquiries.Header"),
      },
      body: {
        component: () => import("./ClientInquiries.Body"),
        grayBackground: true,
      },
    },
    group: "Clients",
    searchAliases: [
      "client answers",
      "inquiry answers",
      "client decisions",
      "client questions",
    ],
    requiresAuth: true,
    requiresPermission: false,
    onEnter: ({ rootStore }) => {
      void storeOf(rootStore)?.initialize();
    },
    onExit: ({ rootStore }) => {
      // Clean slate: page, open answer, filters, and any in-flight load.
      storeOf(rootStore)?.reset();
    },
  },
];

export default clientInquiriesRoute;
